import { createFileRoute, useNavigate, useRouter } from '@tanstack/react-router'
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards, Navigation, Virtual } from 'swiper/modules';
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { io } from "socket.io-client";

//@ts-expect-error
import 'swiper/css';
//@ts-expect-error
import 'swiper/css/effect-cards';
//@ts-expect-error
import 'swiper/css/navigation';
import styles from './styles.module.scss'
import { CardBuyPreview } from '@/components/desktop/card-buy-preview';
import { cardsServiceInstance } from '@/services/cards.service';
import { currencyFormat } from '@/utils/currency-format';
import { useCallback, useEffect, useState } from 'react';
import { useBoolean, useCampaignContext } from '@/hooks';
import { CardSelectedForBuy } from '@/components/desktop/card-selected-for-buy';
import { transactionsServiceInstance, type CreateTransactionOutput } from '@/services/transaction.service';
import { ModalPayment } from '@/components/ui/modal-payment';
import { ModalLuck } from '@/components/ui/modal-luck';
import { useAtom } from 'jotai';
import { userAtom } from '@/store/atoms/user.atom';
import { ModalUseSaud } from '@/components/ui/modal-use-saud';
import toast from 'react-hot-toast';
//@ts-expect-error
import terminal from 'virtual:terminal';
import { AxiosError } from 'axios';

export const Route = createFileRoute('/desktop/__app/buy/')({
  component: RouteComponent,
  loader: async () => {
    const response = await cardsServiceInstance.pickForPurchase()

    return {
      cards: response
    }
  },
  shouldReload: true,
})

function RouteComponent() {
  const { cards: cardsData } = Route.useLoaderData()

  const { campaign } = useCampaignContext()
  const [cards, setCards] = useState(cardsData);
  const [selectedCards, setSelectedCards] = useState<typeof cardsData>([])
  const [currentTransaction, setCurrentTransaction] = useState<CreateTransactionOutput | undefined>(undefined)
  const [isOpenModalTransaction, handleOpenModalTransaction, handleClosemodalTransaction] = useBoolean()
  const [isOpenModalLuck, handleOpenModalLuck, handleCloseModalLuck] = useBoolean()
  const navigator = useNavigate()
  const [currentUser, setCurrentUser] = useAtom(userAtom)
  const router = useRouter()
  const [isOpenModalUseSaud, handleOpenModalUseSaud, handleCloseModalUseSaud] = useBoolean()
  useEffect(() => {
    const socket = io('https://sortelecadmdashboard.com', {
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
      transports: ['websocket']
    })

    socket.on("lock-card", msg => {
      terminal.log(msg)
      setCards(prev => prev.filter(card => card.id !== msg))
      setSelectedCards(prev => prev.filter(card => card.id !== msg))
    })
  }, [])
  const handleUseSaud = useCallback(async () => {
    const pricing = selectedCards.length * campaign!.value
    if (currentUser!.wallet.amount < pricing) {
      toast.error("Saldo insuficiente. Remova uma ou mais cartelas do carrinho para continuar.")
      return
    }
    await transactionsServiceInstance.useSaud({
      cards: selectedCards.map(c => c.id)
    })

    // if (response.length > 0) {
    //   await createTransactionWhenUseSaud(response)
    //   handleCloseModalUseSaud()
    //   return
    // }
    handleCloseModalUseSaud()
    const value = selectedCards.length * campaign!.value
    // const wallet = await userServiceInstance.wallet()
    if (currentUser) {
      setCurrentUser({
        ...currentUser,
        wallet: {
          ...currentUser.wallet,
          amount: currentUser.wallet.amount - value
        }
      })
    }
    router.navigate({ to: '/desktop/game' })
  }, [currentUser, selectedCards, cards])

  const handleCreateTransaction = useCallback(async () => {
    try {

      const response = await transactionsServiceInstance.create({
        cards: selectedCards.map(c => c.id)
      })
      setCurrentTransaction(response)
      handleOpenModalTransaction()
    } catch (err) {
      if (err instanceof AxiosError) {
        toast.error(err?.response?.data?.message)
      }
    }
  }, [selectedCards])

  const handleSelectCard = useCallback((cardId: string) => {
    const cardExists = selectedCards.find(c => c.id === cardId)
    if (cardExists) {
      setCards(prev => ([...prev, cardExists]))
      return setSelectedCards(prev => prev.filter(c => c.id !== cardId))
    }
    const card = cards.find(c => c.id === cardId)
    if (!card) return
    setSelectedCards(prev => [...prev, card])
    setCards(prev => prev.filter(c => c.id !== cardId))
  }, [cards, selectedCards])

  const refreshCards = useCallback(async () => {
    const cards = await cardsServiceInstance.pickForPurchase()
    setCards(cards)
    setSelectedCards([])
  }, [])

  const onConfirmLuck = useCallback((quantity: number) => {
    const selecteds = cards.slice(0, quantity)

    setCards(prev => prev.filter(c => !selecteds.find(card => card.id === c.id)))
    setSelectedCards(selecteds)
    handleCloseModalLuck()
  }, [cards])

  if (!campaign) return null

  return (
    <div className={styles.container}>
      <div className={styles.first__section}>
        <header>
          <img
            src="/assets/signboard.svg"
          />
          <h3>Selecione uma cartela</h3>
        </header>
        <div>
          <button className={styles.btn_prev}>
            <ArrowLeft />
          </button>
          <Swiper
            effect={'cards'}
            grabCursor={true}
            modules={[EffectCards, Navigation, Virtual]}
            navigation={{
              enabled: true,
              prevEl: `.${styles.btn_prev}`,
              nextEl: `.${styles.btn_next}`
            }}
            virtual
            className="mySwiper"
          >
            {
              cards.map(card => (
                <SwiperSlide>
                  <CardBuyPreview
                    cardsNumbers={card.cardBalls}
                    key={card.id}
                    onSelect={() => handleSelectCard(card.id)}
                  />

                </SwiperSlide>
              ))
            }
          </Swiper>

          <button className={styles.btn_next}>
            <ArrowRight />
          </button>
        </div>

        <footer>
          <button onClick={refreshCards}>
            <img
              src="/assets/update-desk.png"
            />
          </button>
          <button onClick={handleOpenModalLuck}>
            <img
              src="/assets/god-luck-desk.png"
            />
          </button>
        </footer>
      </div>
      <div className={styles.second__section}>
        <header>
          <img
            src='/assets/your-cards.png'
          />
        </header>
        <div>
          {
            selectedCards.map(card => (
              <CardSelectedForBuy
                numbers={card.cardBalls}
                key={card.id}
                onRemove={() => {
                  setSelectedCards(prev => prev.filter(c => c.id !== card.id))
                  setCards(prev => [...prev, card])
                }}
              />
            ))
          }
        </div>
        <footer>
          <div>
            <img
              src="/assets/signboard.svg"
            />
            <b>Cartelas:</b>
            <span>{selectedCards.length}</span>
          </div>
          <div>
            <img
              src="/assets/coin.svg"
            />
            <b>Custo:</b>
            <span>{currencyFormat(selectedCards.length * campaign?.value)}</span>
          </div>
          <button disabled={!selectedCards.length} onClick={currentUser?.wallet && currentUser?.wallet.amount > 0 ? handleOpenModalUseSaud : handleCreateTransaction}>
            <img
              src="/assets/btn_play.png"
            />
          </button>
        </footer>
      </div>
      {
        currentTransaction && isOpenModalTransaction && (
          <ModalPayment
            onClose={handleClosemodalTransaction}
            transaction={currentTransaction}
            onSuccess={() => {
              handleClosemodalTransaction()
              navigator({
                to: '/desktop/game',
              })
            }}
          />
        )
      }
      {
        isOpenModalLuck && (
          <ModalLuck
            onClose={handleCloseModalLuck}
            onConfirm={onConfirmLuck}
          />
        )
      }
      {
        isOpenModalUseSaud && (
          <ModalUseSaud
            transactionValue={selectedCards.length * campaign?.value}
            pay={handleUseSaud}
            onClose={handleCloseModalUseSaud}
          />
        )
      }
    </div>
  )
}
